import { type Map as ImMap, is, type List, OrderedMap } from 'immutable';
import { createSelector } from 'reselect';

import { transactionsSelectors } from 'app-components/flux/transactions';
import type { TransactionRecord } from 'app-components/flux/transactions/transactionsTypes';
import { defaultCollator } from 'app-components/utils/strings';

export const getPayeesForTransactions = createSelector(
  transactionsSelectors.getTransactionsById,
  (transactions: ImMap<string, TransactionRecord>): OrderedMap<string, string> =>
    OrderedMap<string, string>().withMutations((payees) =>
      transactions.forEach((transaction) => {
        const key = transaction.payee?.toLowerCase();
        if (
          transaction.type === 'CASH_FLOW' &&
          !transaction.isDeleted &&
          transaction.payee?.length &&
          key &&
          !payees.has(key)
        ) {
          payees.set(key, transaction.payee);
        }
      }),
    ),
  // Preserve ordering and display casing while reusing the catalog after unrelated transaction edits.
  { memoizeOptions: { resultEqualityCheck: is } },
);

export const getPayeesNamesSorted = createSelector(
  getPayeesForTransactions,
  (payeesMap): List<string> => payeesMap.toList().sort(defaultCollator.compare),
);
